import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MaintenanceEstablishmentChoiceAuctionEntryData } from '../types/auctionEntry.type';

interface UseMaintenanceEstablishmentChoiceAuctionEntryProps {
  auctionEntryId: string | undefined;
  options?: Partial<Omit<UseQueryOptions<
    { data: { data: MaintenanceEstablishmentChoiceAuctionEntryData; } },
    ErrorResponse,
    MaintenanceEstablishmentChoiceAuctionEntryData
  >, 'queryKey' | 'queryFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntry = ({
  auctionEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled: !!auctionEntryId,
    queryKey: ['maintenanceEstablishmentChoiceAuctionEntry', auctionEntryId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/auction_entries/${auctionEntryId}`);
    },
    select: (response) => response?.data?.data,
    ...options
  });
}
